// extracted by mini-css-extract-plugin
module.exports = {"m4w":"GoodDeal_m4w_29AAb","m4w--ddc":"GoodDeal_m4w--ddc_5G3PS","m4w--ddc--rolls-royce":"GoodDeal_m4w--ddc--rolls-royce_1gfQP","m4w--img":"GoodDeal_m4w--img_28uTW"};